import React from 'react'
import PPVTemplate from 'src/components/page/ppv'
import { promoCodes } from 'src/constants'

export default (props) => {
  return (
    <PPVTemplate
      lang="en"
      market="us"
      location={props.location}
      title="AEW All Out: Toronto 2025"
      subtitle="Watch live this Saturday, September 20, on Pay Per View with Fubo"
      heroFootnote="Fubo subscription not required"
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/PPV_AEW_Toronto_16x9.mp4'}
      videoMobile={'https://assets.fubo.tv/marketing/lp/videos/mobile/PPV_AEW_Toronto_1x1.mp4'}
      offerCode={promoCodes.aew_all_out_toronto_2025}
      additionalFAQs={additionalFAQs}
      isEventEnded={true}
    />
  )
}

const additionalFAQs = [
  {
    question: 'Can I watch AEW All Out: Toronto 2025 on Fubo?',
    answer:
      'Yes, AEW All Out: Toronto 2025 is available as a Pay Per View event on Fubo. A Fubo paid plan is not required to buy the Pay Per View event.',
  },
  {
    question: 'How do I find AEW All Out: Toronto 2025 on Fubo?',
    answer:
      'If you ordered the AEW All Out: Toronto 2025 Pay Per View event, coverage will be on the Pay Per View channel in the channel guide. You can type “pay per view” in Fubo’s search bar.',
  },
  {
    question: 'Will AEW All Out: Toronto 2025 be replayed on Fubo?',
    answer:
      'Yes, if you miss the event or want to watch it again, AEW All Out: Toronto 2025 will be replayed on Fubo for a period of time after the event ends.',
  },
  {
    question: 'Can I watch John Moxley in AEW All Out: Toronto 2025 on Fubo?',
    answer:
      'Absolutely! John Moxley will be featured in AEW All Out: Toronto 2025 in a Coffin Match with Darby Allin.',
  },
  {
    question: 'Is Mercedes Moné appearing in AEW All Out: Toronto 2025 on Fubo?',
    answer:
      'Yes, Mercedes Moné is set to appear in AEW All Out: Toronto 2025 against Riho in the TBS Championship.',
  },
  {
    question: 'Can I watch the All Out Zero Hour preshow on Fubo?',
    answer:
      'Yes, the live All Out Zero Hour preshow will be included as part of the AEW All Out: Toronto 2025 Pay Per View event on Fubo.',
  },
  {
    question: 'Will Toni Storm be part of AEW All Out Toronto 2025 on Fubo?',
    answer:
      "Yes, “Timeless” Toni Storm will be in the AEW Women's World Championship 4-way with Jamie Hayter, Kris Statlander and Thekla. This is one of the most anticipated matches in AEW All Out: Toronto 2025.",
  },
]
